
export interface DonutSegment {
  label: string;
  value: number;
  color: string;
}

export function DonutChart({
  segments,
  centerValue,
  centerLabel,
  className,
}: {
  segments: DonutSegment[];
  centerValue: string;
  centerLabel: string;
  className?: string;
}) {
  const hasFigure = segments.some((s) => s.value > 0);
  const total = segments.reduce((s, x) => s + x.value, 0) || 1;
  let acc = 0;
  const stops = segments.map((s) => {
    const start = (acc / total) * 100;
    acc += s.value;
    const end = (acc / total) * 100;
    return `${s.color} ${start}% ${end}%`;
  });
  const conic = `conic-gradient(${stops.join(',')})`;

  if (!hasFigure) {
    return (
      <p className={`py-6 text-center text-body-sm text-on-surface-variant ${className || ''}`}>
        Nothing has reached this stage yet. Deals move here as they are worked, not before.
      </p>
    );
  }
  return (
    <div className={`flex flex-wrap items-center gap-5 ${className || ''}`}>
      <div className="relative h-[130px] w-[130px] shrink-0 rounded-full" style={{ background: hasFigure ? conic : 'transparent' }} role="img" aria-label={`${centerLabel}: ${centerValue}`}>
        {!hasFigure && <div className="absolute inset-0 rounded-full border-2 border-dashed border-border" />}
        <div className="absolute inset-[22px] flex flex-col items-center justify-center rounded-full bg-card">
          <span className="font-mono text-data-lg font-semibold tabular-nums text-on-surface">{hasFigure ? centerValue : '—'}</span>
          <span className="text-label-caps uppercase tracking-wider text-on-surface-subtle">{centerLabel}</span>
        </div>
      </div>
      <div className="flex min-w-[130px] flex-1 flex-col gap-2">
        {segments.map((seg) => (
          <div key={seg.label} className="flex items-center gap-2">
            <span className="h-2.5 w-2.5 shrink-0 rounded-[3px]" style={{ backgroundColor: seg.color }} />
            <span className="flex-1 truncate text-body-sm text-on-surface-variant">{seg.label}</span>
            <span className="font-mono text-data-md tabular-nums text-on-surface">{seg.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
